import { get, post } from '@apis/api';
import { Product } from '@wconcept/wconcept-common/models/display/product';
import { CommonResponse } from '@models/api';

const eventBaseURL = process.env.NEXT_PUBLIC_EVENT_API_BASE_URL;
const eventOptions = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'EVENT-API-KEY': process.env.NEXT_PUBLIC_EVENT_API_KEY || '',
  },
};

// 타입 정의
export interface IAlarmRes {
  alarmCompleteDate?: string;
  alarmDesc?: string;
  alarmDueDate?: string;
  alarmId?: number;
  alarmTitle?: string;
  applyEndDate?: string;
  applyStartDate?: string;
  applyYn?: 'Y' | 'N';
  eventId?: number;
  sectionId?: number;
  sendYn?: 'Y' | 'N';
  authNecessaryYn?: 'Y' | 'N';
  receiveAgreeType?: 'PUSH' | 'BASIC' | 'NONE';
}

export type ApplyResultType =
  | 'COMPLETED'
  | 'DUPLICATED'
  | 'APPLY_NOTFOUND'
  | 'INVALID_CONDITION'
  | 'INVALID_CUSTOMER';

export interface EventAlarmApplyResV1 {
  applyResult: ApplyResultType;
  alarmId: number;
  eventId: number;
  sectionId: number;
  custNo: number;
  custId: string;
  appYn: 'Y' | 'N';
}

export interface IRouletteResult {
  rouletteId: number;
  eventId: number;
  sectionId: number;
  rouletteTitle: string;
  rouletteDesc: string;
  prizeType: string;
  entryStartDate: string;
  entryEndDate: string;
  nextRouletteYn: string;
}

export interface IRouletteEntryResult {
  custNo: number;
  entryResult: string;
  nextRouletteYn: string;
  couponInfo: {
    couponMasterSeqNo: number;
    customerCouponSeqNo: number;
    customerCouponCd: string;
    couponName: string;
    discountAmt: number;
    discountRate: number;
  };
}

export interface ISectionProductItem extends Product {
  eventBeginDateTime: null | string;
  eventCurrentDateTime: null | string;
  eventEndDateTime: null | string;
  todayDeliveryTag: boolean;
}
export interface ICategoryProdct {
  id: number;
  sectionId: number;
  tabId: number;
  productCd: string;
  sort: number;
  userId: string;
  product: ISectionProductItem;
}

/**
 *
 * @summary 실시간 랭킹 상품 목록
 * @param {string} categoryKey
 */
export const requestGetCategoryRankProducts = async (categoryKey: string) => {
  const res = await get<{
    data: ICategoryProdct[];
    baseData: {
      updateTime: string;
    };
  }>({
    url: `/event/api/v1/recommend/wweek/${categoryKey}`,
    baseUrl: eventBaseURL,
    options: eventOptions,
  });
  return res;
};

/**
 * 이벤트 알람 조회
 */
export const requestGetEventAlarm = async (
  alarmId: number,
  custNo?: string
) => {
  const { data } = await get<
    CommonResponse<IAlarmRes>,
    {
      custNo: number;
      eventId: number;
    }
  >({
    url: `/event/api/v1/alarm/${alarmId}?custNo=${custNo || ''}`,
    baseUrl: eventBaseURL,
    options: eventOptions,
  });
  return data;
};

/**
 * 이벤트 알람 신청
 */
export const requestSetEventAlarm = async ({
  eventId,
  sectionId,
  alarmId,
  custNo,
  custId,
  appYn,
}: {
  eventId: number;
  sectionId: number;
  alarmId: number;
  custNo: string;
  custId: string;
  appYn: 'Y' | 'N';
}) => {
  const data = await post<
    CommonResponse<EventAlarmApplyResV1>,
    {
      eventId: number;
      sectionId: number;
      custNo: string;
      custId: string;
      appYn: 'Y' | 'N';
    }
  >({
    url: `/event/api/v1/alarm/apply/${alarmId}`,
    baseUrl: eventBaseURL,
    options: eventOptions,
    data: {
      eventId,
      sectionId,
      custNo,
      custId,
      appYn,
    },
  });
  return data;
};

/**
 * 룰렛 조회
 */
export const requestGetRoulette = async (sectionId: number) => {
  const { data } = await get<CommonResponse<IRouletteResult>>({
    url: `/event/api/v1/roulette/${sectionId}`,
    baseUrl: eventBaseURL,
    options: eventOptions,
  });
  return data as IRouletteResult;
};

/**
 * 룰렛 응모
 */
export const requestRouletteEntry = async ({
  rouletteId,
  custNo,
}: {
  rouletteId: number;
  custNo: number;
}) => {
  const { data } = await post<CommonResponse<IRouletteEntryResult>>({
    url: `/event/api/v1/roulette/entry/${rouletteId}`,
    baseUrl: eventBaseURL,
    options: eventOptions,
    data: { rouletteId, custNo },
  });
  return data as IRouletteEntryResult;
};
